// Lightweight tap-to-audio timing log. Enabled when
// `localStorage['debug:playTiming'] === '1'` or `window.__playTimingOn = true`.
// Each `mark()` prints the ms elapsed since the last `start()` and the total
// since that start. Use this to see which segment dominates the per-tap delay:
//   start('tap')          ← user pressed play
//   mark('onAudioPlay')   ← jinke fires
//   mark('engine.play')   ← Capacitor bridge call about to fire
//   (Swift side logs its own marks via NSLog)
//   mark('avplayer.playing') ← AVPlayer KVO reports playing (driven from Swift)
//
// Zero overhead when disabled (early return on the flag check).

let _anchorMs = 0;
let _lastMs = 0;
let _label = '';

function _enabled() {
  if (typeof window === 'undefined') return false;
  if (window.__playTimingOn === true) return true;
  try { return window.localStorage?.getItem('debug:playTiming') === '1'; } catch { return false; }
}

export function start(label) {
  if (!_enabled()) return;
  _anchorMs = performance.now();
  _lastMs = _anchorMs;
  _label = label || 'tap';
}

export function mark(label) {
  if (!_enabled() || _anchorMs === 0) return;
  const now = performance.now();
  const delta = Math.round(now - _lastMs);
  const total = Math.round(now - _anchorMs);
  _lastMs = now;
}
